<template>
<main class="L_ContactUsHolder">
    <div class="G_BorderRadius L_ContactUsFormHolder">
        <div class="G_DisplayRowNowrap G_HeadingFont L_ContactUsHeadingHolder">
            Contact Us
        </div>
        <div class="L_ContactFormDescHolder">
            <div class="G_DisplayColumnNowrap G_NormalFont L_ContactUsFormDesc">
                <div>
                    If you would like to contact us about our products, any enquiries or about our website, please don't hesitate to
                    fill in your details and submit the form or contact us directly with the details provided.
                </div>
                <br>
                <div>
                    Alernatively you can Whatsapp us at <u style="cursor:pointer" @click="OpenWhatsapp()">here</u>.
                </div>
            </div>
            <div class="G_DisplayColumnNowrap L_ContactUsForm">
                <input class="G_Input G_BorderRadius G_NormalFont G_BorderBlack L_Input" placeholder="Name" v-model="ContactUs.Name" />
                <!-- <input class="G_Input G_BorderRadius G_NormalFont G_BorderBlack L_Input" placeholder="Email" v-model="ContactUs.Email"/> -->
                <input class="G_Input G_BorderRadius G_NormalFont G_BorderBlack L_Input" placeholder="Number" v-model="ContactUs.Number" />
                <textarea class="G_TextArea G_BorderRadius G_NormalFont G_BorderBlack L_TextArea" placeholder="Message" v-model="ContactUs.Message" />
                <button class="G_BorderRadius G_Border G_NormalFontWhite L_SubmitButton" @click="submitContactUs(ContactUs)">Submit</button>
              </div>
            </div>
        </div>
     <TSTAlert v-if="ContactUsSubmitted" :AlertDescription="'We will get back to you soon!'" :class="AlertClass"/>
    </main>
</template>

<script>
import TSTAlert from '../../widgets/TSTAlert.vue'
import firebase from 'firebase/compat/app'

export default {
    components: {
        TSTAlert
    },
    data() {
        return {
            ContactUs: {
                Name: "",
                // Email: "",
                Message: "",
                Number: ""
            },
            ContactUsSubmitted: false,
            AlertClass: "L_AlertHolderNoShowContact"
        }
    },
    methods: {
        submitContactUs(ContactUs) {
            var Error = ""

            if (this.IsEmpty(ContactUs.Name)) Error += "Please insert a name.\n"
            if (!this.IsNumber(ContactUs.Number) || ContactUs.Number.length != 10 || this.IsEmpty(ContactUs.Number)) Error += "Please insert a valid number.\n"
            if (this.IsEmpty(ContactUs.Message)) Error += "Please insert a message.\n"

            if (!this.IsEmpty(Error)) {
                alert(Error)
                return
            } else {
                this.ContactUsSubmitted = true
                this.AlertClass = "L_AlertShowContact"
                var scope = this

                setTimeout(
                    function () {
                        scope.AlertClass = "L_AlertHolderNoShowContact"
                        scope.$emit("SetSelectedComp", "Home")

                    }, 4500
                )

                var DB = firebase.firestore()
                DB.collection("contact_us")
                    .add({
                        contact_details: ContactUs,
                    })

                fetch("https://api.telegram.org/bot6033274730:AAEGvQCBYJEcfr7NEo_wX6OA0vkbohSnHQI/sendMessage?chat_id=-801761326&text=" +
                    "Contact this person:" +
                    "%0A" +
                    "Name: " + ContactUs.Name +
                    "%0A" +
                    "Number: " + ContactUs.Number +
                    "%0A" +
                    "Message: " + ContactUs.Message
                )
            }
        },
        OpenWhatsapp() {
            window.open("https://wa.me/270663421732")
        },
        IsNumber(Num) {
            var ValidChars = "0123456789";
            var IsNumber = true;
            var Char;
            for (var i = 0; i < Num.length && IsNumber == true; i++) {
                Char = Num.charAt(i);
                if (ValidChars.indexOf(Char) == -1) IsNumber = false;
            }

            return IsNumber;
        },
        IsEmpty(Val) {
            if (!Val) return true;
            if (typeof Val == "object" && Object.keys(Val).length === 0) return true;
            if (typeof Val == "array" && Val.length === 0) return true;
            return false;
        }
    }
}
</script>

<style lang="scss">
@import "../../../assets/GlobalCss.scss";

.L_ContactUsHolder {
    width: 100%;
    height: 30rem;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;

    @include mobile() {
        height: 40rem;
    }

}

.L_ContactUsFormHolder {
    width: 50%;
    height: 90%;
    justify-content: center;
    align-items: center;

    @include mobile() {
        width: 90%;
    }
}

.L_ContactUsHeadingHolder {
    width: 100%;
    height: 10%;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
}

.L_ContactFormDescHolder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;

    @include mobile() {
        flex-flow: column nowrap;
        height: 80%;
    }
}

.L_ContactUsFormDesc {
    width: 40%;
    height: 100%;

    @include mobile() {
        width: 100%;
        margin-bottom: 2rem;
    }
}

.L_ContactUsForm {
    width: 40%;
    height: 90%;
    justify-content: space-around;

    @include mobile() {
        width: 100%;
        height: 70%;
        align-items: center;
    }
}

.L_Input,
.L_TextArea {
    width: 90%;

    @include mobile() {
        margin-bottom: .5rem;
    }
}

.L_SubmitButton {
    margin-bottom: 1rem;
    width: 13rem;
    background-color: #F3CBBB;
    cursor: pointer;
}

.L_SubmitButton:hover {
    transition: .2s ease;
    background-color: #FFFFFF;
    color: #F3CBBB;
}

.L_AlertHolderNoShowContact {
    display: none;
}

.L_AlertShowContact {
    position: absolute;
    animation: AlertContact 4.5s ease-in-out forwards;
}

@keyframes AlertContact {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>
